import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../shared/services/base.service";


@Injectable({
    providedIn: 'root',
})
export class ChatbotService {
    private cache: { [url: string]: any } = {};

    constructor(
        public readonly baseService: BaseService
    ) {}

    getChatbotInfo(
        baseSiteId: string
    ): Observable<any> {
        if (this.cache[baseSiteId]) {
            return this.cache[baseSiteId];
        } else {
            this.cache[baseSiteId] = this.baseService.get('/chat-bot/info');
            return this.cache[baseSiteId];
        }
    }
}
